module.exports = __webpack_public_path__ + "img/kafe.4ffd89f4.png";